var render, staticRenderFns
import script from "./ConferenceRoom.vue?vue&type=script&lang=js&"
export * from "./ConferenceRoom.vue?vue&type=script&lang=js&"
import style0 from "./ConferenceRoom.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c817c74')) {
      api.createRecord('1c817c74', component.options)
    } else {
      api.reload('1c817c74', component.options)
    }
    
  }
}
component.options.__file = "module/Vrcci/Conference/resources/vue/ConferenceRoom.vue"
export default component.exports